import { calculateTotalMonthsForSingleProduct } from './calculateTotalMonths'
import dayjs from 'dayjs'

// constants.ts
export const MANUAL_STATUSES = new Set(['Cancelled', 'Monthly', 'Expired'])

// Terminal deal statuses — when a deal is in one of these, product statuses should never be recalculated
export const TERMINAL_DEAL_STATUSES = new Set(['Ended', 'Cancelled', 'Replaced'])

export const calculateProductStatus = (startDate: string, endDate: string): 'Active' | 'Ended' | 'Pending' => {
  const today = dayjs()
  const start = dayjs(startDate)
  const end = dayjs(endDate)

  if (!start.isValid() || !end.isValid()) return 'Pending'

  if (today.isBefore(start)) return 'Pending'
  if (today.isAfter(end)) return 'Ended'
  return 'Active'
}

// date + math helpers (no Dayjs left in Product objects)
export const toISO = (v: any) =>
  (v && typeof v.toISOString === 'function' ? v.toISOString() : typeof v === 'string' ? v : '') as string
export const num = (x: any) => (x === '' || x == null ? 0 : Number(x))
export const round2n = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100
export const toFixed2s = (n: number) => round2n(n).toFixed(2) // string

// derive months only when both dates exist
export const monthsFor = (startISO?: string, endISO?: string) =>
  startISO && endISO ? calculateTotalMonthsForSingleProduct(startISO, endISO) || 1 : 1

// status helper (respects manual statuses)
export const computeStatusIfAuto = (currentStatus: string | undefined, startISO: string, endISO: string) =>
  currentStatus && MANUAL_STATUSES.has(String(currentStatus))
    ? currentStatus
    : startISO && endISO
    ? calculateProductStatus(startISO, endISO)
    : currentStatus
